import api from '../lib/axios';
import { downloadFile } from '../lib/download';
export async function getEvents(params) {
    const { data } = await api.get('/api/admin/events', { params });
    return data;
}
export async function getEvent(id) {
    const { data } = await api.get(`/api/admin/events/${id}`);
    return data.data;
}
export async function createEvent(body) {
    const { data } = await api.post('/api/admin/events', body);
    return data.data;
}
export async function updateEvent(id, body) {
    const { data } = await api.patch(`/api/admin/events/${id}`, body);
    return data.data;
}
export async function deleteEvent(id) {
    await api.delete(`/api/admin/events/${id}`);
}
export async function getEventRegistrations(eventId) {
    const { data } = await api.get(`/api/admin/events/${eventId}/registrations`);
    return data;
}
export async function deleteEventRegistration(eventId, registrationId) {
    await api.delete(`/api/admin/events/${eventId}/registrations/${registrationId}`);
}
export function exportEventRegistrationsCsv(eventId) {
    return downloadFile(`/api/admin/events/${eventId}/registrations/export`, `inscrits_${new Date().toISOString().slice(0, 10)}.csv`);
}
